type ActivationSetupIntroProps = {
  customerAreaLabel: string
  title: string
  subtitle: string
  checklistItems: string[]
  contextNote: string
  showChecklist: boolean
}

export const ActivationSetupIntro = ({
  customerAreaLabel,
  title,
  subtitle,
  checklistItems,
  contextNote,
  showChecklist,
}: ActivationSetupIntroProps) => (
  <>
    <div className="space-y-3.5">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-(--color-status-info)">{customerAreaLabel}</p>
      <h1 className="max-w-[20ch] text-balance text-3xl font-semibold tracking-tight text-(--color-text-primary) sm:text-4xl lg:text-[2.6rem]">
        {title}
      </h1>
      <p className="max-w-[64ch] text-sm leading-relaxed text-(--color-text-secondary) sm:text-base">{subtitle}</p>
    </div>

    {showChecklist ? (
      <div className="space-y-4 border-y border-[color-mix(in_srgb,var(--color-border-default)_78%,transparent)] py-4">
        <ul className="space-y-3">
          {checklistItems.map((item) => (
            <li key={item} className="flex items-start gap-2.5 text-sm text-(--color-text-secondary)">
              <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--color-status-success)_16%,transparent)] text-(--color-status-success)">
                <svg viewBox="0 0 20 20" className="h-3.5 w-3.5 fill-none stroke-current stroke-[2.2]" aria-hidden>
                  <path d="m4.5 10.4 3.3 3.3 7.2-7.2" />
                </svg>
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <p className="text-xs leading-relaxed text-(--color-text-muted)">{contextNote}</p>
      </div>
    ) : null}
  </>
)
